import React from 'react';
import type { FC } from 'react';

interface TextIconProps {
    className?: string;
}

export const TextIcon: FC<TextIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Text Icon</title>
            <g clipPath="url(#clip0_1568_3667)">
                <path
                    d="M9.16797 12.998H10.8346"
                    stroke="white"
                    strokeWidth="1.2"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.0013V7.16797"
                    stroke="white"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 8.0013V7.16797H12.5V8.0013"
                    stroke="white"
                    strokeWidth="1.2"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5866 1.96094H3.41185C2.74419 1.96094 2.20492 2.50588 2.21191 3.1735L2.35345 16.6935C2.36034 17.3513 2.89555 17.8809 3.55339 17.8809H16.445C17.1029 17.8809 17.6381 17.3513 17.645 16.6935L17.7865 3.1735C17.7935 2.50588 17.2542 1.96094 16.5866 1.96094Z"
                    stroke="white"
                    strokeWidth="1.2"
                />
            </g>
            <defs>
                <clipPath id="clip0_1568_3667">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
